import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ExpertRecord, Gender, UserRecord, UserRole } from '@libs/shared/api';
import { environment } from '@sprint-expert-manager/environments/environment';

export interface ChannelConfig {
  pluginKey: string;
  memberId: string;
  profile: {
    id: string;
    email: string;
    name: string;
    role: UserRole;
    birthday: string;
    mobileNumber: string;
    gender: Gender;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ChannelIoService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public loadScript() {
    const w = window;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (w.ChannelIO) {
      return (window.console.error || window.console.log || function () {})(
        'ChannelIO script included twice.'
      );
    }
    const ch = function () {
      // eslint-disable-next-line prefer-rest-params
      ch.c(arguments);
    };
    ch.q = [];
    ch.c = function (args) {
      ch.q.push(args);
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    w.ChannelIO = ch;

    function l() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (w.ChannelIOInitialized) {
        return;
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      w.ChannelIOInitialized = true;
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
      s.charset = 'UTF-8';
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }

    if (document.readyState === 'complete') {
      l();
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.attachEvent) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.attachEvent('onload', l);
      } else {
        window.addEventListener('DOMContentLoaded', l, false);
        window.addEventListener('load', l, false);
      }
    }
  }

  boot(user: UserRecord, expert: ExpertRecord) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ChannelIO('boot', {
      pluginKey: environment.channelPluginKey,
      memberId: user.id,
      profile: {
        id: user.id,
        email: user.emailAddress,
        name: user.nickname,
        role: user.role,
        env: environment.name,
        gender: expert.gender,
      },
    } as ChannelConfig);
  }

  shutdown() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ChannelIO('shutdown');
  }
}
